import { IShoppingListCategory } from './ShoppingList';
import { ImageWithMetadata } from './Image';
import { IIngredientCategory } from './Ingredient';
import { IBedCard } from './BedData';

export enum CardSize {
    LARGE = 'large',
    SMALL = 'small',
}

export interface ICard {
    id: number,
    title: string,
    description: string,
    image: ImageWithMetadata,
    showRatingStars: boolean,
    ratingAverage: number,
    directions: string,
    maxOffers: number,
    shoppingList: IShoppingListCategory[],
    callToActionUrl: string | null,
    ingredientCategories: IIngredientCategory[],
    recipeId: string
}

export const mapFromBedCard: (bedCard: IBedCard) => ICard = (bedCard: IBedCard): ICard => {
    let ra = 0;
    if (bedCard.ratingAverage && bedCard.ratingAverage > 0) {
        ra = Math.round(bedCard.ratingAverage);
    }
    return {
        id: bedCard.id || '',
        title: bedCard.title || '',
        description: bedCard.description || '',
        image: bedCard.image || new ImageWithMetadata(0, 0, '', ''),
        showRatingStars: !!bedCard.showRatings,
        ratingAverage: ra,
        directions: bedCard.directions || '',
        maxOffers: bedCard.maxOffers || 5,
        shoppingList: bedCard.shoppingLists || [],
        callToActionUrl: bedCard.ctaButtonUrl || '',
        ingredientCategories: bedCard.ingredientCategories || [],
        recipeId: (bedCard.recipeId) ? bedCard.recipeId.toString() : '',
    } as ICard;
};

export const DefaultCard: ICard = {
    id: -1,
    title: '',
    description: '',
    image: new ImageWithMetadata(0, 0, '', ''),
    showRatingStars: false,
    ratingAverage: 5,
    directions: '',
    maxOffers: 5,
    shoppingList: [],
    callToActionUrl: '',
    ingredientCategories: [],
    recipeId: '',
};
